import React from 'react';
import { CircularProgress } from '@mui/material';

const FullWidthLoader = () =>
{
	return (
		<div className='loaderCntnrBg fullWidthLoader'>
			<CircularProgress />
		</div>
	);
};

export default FullWidthLoader;